export default {
	SET_AVAILABLE_ACCOUNTS: (state, accounts) => {
		state.availableAccounts = accounts;
	},
	SET_USER_TOKEN_DATA(state, data) {
		state.userTokenData = data;
	}
};
